export class LlgResourcePolicy {
    'vaultId';
    'backupRetentionDays';
    'scheduleConfig';
    'cutoffDays';
    'includedPrefixes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "backupRetentionDays",
            "baseName": "backupRetentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "scheduleConfig",
            "baseName": "scheduleConfig",
            "type": "HighFrequencyBackupScheduleConfig",
            "format": ""
        },
        {
            "name": "cutoffDays",
            "baseName": "cutoffDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "includedPrefixes",
            "baseName": "includedPrefixes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LlgResourcePolicy.attributeTypeMap;
    }
    constructor() {
    }
}
